// extracted by mini-css-extract-plugin
module.exports = {"navbar":"Navbar_navbar__1ZgN2","logo":"Navbar_logo__3dVPq"};